import store_fiche from "@/store/mods/consultations/fiche-consultations"
import { ref } from 'vue'
import $ from 'jquery'

export default {
    name: 'manage-grossesse',
    components: {},
    props: {
        evolution_id: Number,
        consultation_id: Number,
        user_id: Number,
        info_patient: Object,
        info_user: Object,
        group_id: Number,
        grs_toggler: Number,
        selected_grossesse: Array,
        data_to_be_deleted: Object
    },
    data() {
        return {
            save_loading: false,
            is_loading: true,
            grossesse_data: {
                v_model: []
            },
            fields: [
                'grossesse_date_derniere_regles', 'grossesse_age', 'grossesse_date_prob_accouchement',
                'grossesse_albuminurie', 'grossesse_albuminurie_niveau_plus', 'grossesse_hauteur_uterine', 
                'grossesse_bdcf', 'grossesse_bdcf_bpm', 'grossesse_presence_oedeme', 'grossesse_maf'
            ],

            
            gros_albuminurie: [
                'Positif', 'Négatif'
            ],
            gros_albuminurie_niveau: [
                '+', '++', '+++'
            ],
            oui_non_data: [
                'Non', 'Oui'
            ],
            bdcf_data: [
                'Absent', 'Présent'
            ],

            is_error: false,
            permission_is_denied: false,
            del_loading: false,
            is_confirm: false,

            d_date: ref(new Date().toISOString().split('T')[0])
        }
    },

    watch : {
        grs_toggler() {
            this.initFields()
        }
    },

    computed: {

    },

    mounted() {},

    methods: {
        initFields() {
            this.is_loading = true
            this.grossesse_data = {
                v_model: []
            }
            
            var i = 0
            
            this.fields.forEach((fld, index) => {
                var v = ''
                if (this.selected_grossesse.length > 0) {
                    v = this.selected_grossesse[index]['field_content']
                } 
                
                this.grossesse_data.v_model.push({
                    field_name: fld,
                    value: v
                })
                i++

                if (i == (this.fields.length - 1)) {
                    this.is_loading = false
                }
            });
        },

        calculAgeGrossesse() {
            console.log(this.grossesse_data);
            const date_ddr = new Date(this.grossesse_data.v_model[0].value)
            const curr_date = new Date()
            const diff_days = Math.floor((curr_date - date_ddr) / (1000 * 60 * 60 * 24))

            // calcul en SA (Semaine d'aménorrhée)
            const w = Math.floor(diff_days / 7)
            const d = diff_days % 7

            let age_grossesse = ''

            if (w > 0) {
                age_grossesse = w + ' SA '
            }
            if (d > 0) {
                age_grossesse += (w > 0)?'+ ':''
                age_grossesse += d + ' jour(s)'
            }
            this.grossesse_data.v_model[1].value = age_grossesse

            this.calculDateProbableAccouchement()
        },

        calculDateProbableAccouchement() {
            const date_ddr = new Date(this.grossesse_data.v_model[0].value)
            const dpa = new Date(date_ddr.setDate(date_ddr.getDate() + 280)) // 280 jours = 40 semaines
            const day = ('0' + dpa.getDate()).slice(-2)
            const month = ('0' + (dpa.getMonth() + 1)).slice(-2)
            const year = dpa.getFullYear()
            this.grossesse_data.v_model[2].value = year + '-' + month + '-' + day
        },
        
        saveGrossesse() {
            this.permission_is_denied = false
            this.is_error = false

            let data = {
                group_id: this.group_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.user_id,
                user: this.info_user,
                data_type: 'grossesse',
                champs: this.grossesse_data.v_model
            }

            this.save_loading = true

            store_fiche.saveConsultationFicheSectionData(data).then((response) => {
                if (response.success) {
                    this.$refs.mdl_grossesse.click()
                    this.$emit('emitRefreshGrossesse')
                    this.successToast(response.message)

                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs.mdl_grossesse.click()
                this.errorToast("Une erreur s'est produite !")
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerGroupGrossesse(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            this.$store.dispatch('deleteAntecedent', this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Grossesse supprimée avec succès')
                    this.$emit("emitRefreshGrossesse")

                    this.$refs.del_grp_grs.click()
                } else if (response === -2) {
                    this.permission_is_denied = true
                }

                
                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },
    }
}